const extractTiktokUsernameFromLink = ({ url }) => {
    if (!url || url?.length < 1) {
        return null;
    }
    // Define a regular expression pattern to match the username
    const regex = /@([^\/?]+)/;
    // Use match() to find the username in the URL
    const match = url.match(regex);
    // Extract the username from the matched result
    const username = match ? match[1] : null;
    return username;
};
const createTiktokLinkFromUsername = ({ username }) => {
    const formattedUsername = formatTiktokUsername({ username });
    return `https://tiktok.com/${formattedUsername}`;
};
const formatTiktokUsername = ({ username }) => {
    if (!username || username?.length < 1) {
        return null;
    }
    if (username.startsWith('@')) {
        return username;
    }
    return `@${username}`;
};
const extractInstagramShortcodeFromUrl = (url) => {
    // Regular expression to match Instagram URL formats
    const regex = /(?:https?:\/\/)?(?:www\.)?instagram\.com\/p\/([^\/\?]+)/;
    // Extract the shortcode using the regular expression
    const match = url.match(regex);
    // Check if a match is found and return the extracted shortcode
    if (match && match[1]) {
        return match[1];
    }
    else {
        return null;
    }
};
const formatRefUrl = (url) => {
    const parts = url.split('?');
    if (parts.length === 1) {
        return url;
    }
    let baseUrl = parts[0];
    const queryString = parts[1];
    // Ensure there's a single slash before the query string
    if (!baseUrl.endsWith('/')) {
        baseUrl += '/';
    }
    return `${baseUrl}?${queryString}`;
};
export { extractTiktokUsernameFromLink, createTiktokLinkFromUsername, formatTiktokUsername, extractInstagramShortcodeFromUrl, formatRefUrl, };
